import { deepEqual as M } from "fast-equals";
import f from "ip-regex";
import { getNormalizedPatternParts as b, getValueWithPlaceholder as R, getImplicitLoginWebsites as P, getRelatedDomains as L } from "client-core";
import { parse as D } from "tldts";
function v(t) {
  const e = D(t, {
    allowPrivateDomains: !0
  });
  return e.hostname === null || e.hostname.startsWith(".") ? {
    input: t,
    error: {
      message: `Invalid hostname: ${t}`
    }
  } : {
    input: t,
    tld: e.publicSuffix ?? void 0,
    sld: e.domainWithoutSuffix ?? void 0,
    domain: e.domain ?? void 0,
    // tldts returns an empty string when there is no subdomain.
    subdomain: e.subdomain ? e.subdomain : void 0,
    listed: !!e.isIcann || !!e.isPrivate
  };
}
const m = /* @__PURE__ */ new Map();
function S(t) {
  const e = m.get(t);
  if (e)
    return e;
  const r = v(t);
  return m.set(t, r), r;
}
function G(t) {
  const e = v(t);
  return !e.error && e.domain !== void 0;
}
const z = 0;
function K(t, e) {
  const r = c(t);
  if (!r)
    return [];
  const i = A(r);
  return Object.entries(e).map(([s, n]) => O(n, s, r, i)).filter(({
    urlSimilarity: s
  }) => s !== -1 / 0);
}
function O(t, e, r, i) {
  const s = [...t.websites.map((o) => ({
    pattern: o
  })), ...t.scope?.flatMap((o) => {
    const l = R(o);
    return l.kind !== "website" ? [] : {
      pattern: l.pattern
    };
  }) ?? [], ...P(t).flatMap((o) => [{
    pattern: o.website
  }, ...(o.relatedOrigins ?? []).map((l) => ({
    pattern: l,
    fixedSimilarity: z
  }))])], n = (o) => s.flatMap(({
    pattern: l,
    fixedSimilarity: w
  }) => {
    const d = y(o, l);
    return d === void 0 ? [] : {
      urlSimilarity: w ?? d,
      website: l
    };
  });
  let a = h(n(r), "urlSimilarity");
  a.max === -1 / 0 && (a = h(i.flatMap((o) => n(o)), "urlSimilarity"));
  let u;
  for (const {
    website: o
  } of a.results)
    (!u || u.length > o.length) && (u = o);
  return {
    ...t,
    id: e,
    urlSimilarity: a.max,
    maxUrlSimilarityWebsite: u
  };
}
function h(t, e) {
  return t.reduce((r, i) => i[e] > r.max ? {
    max: i[e],
    results: [i]
  } : i[e] === r.max ? {
    max: r.max,
    results: [...r.results, i]
  } : r, {
    max: -1 / 0,
    results: []
  });
}
function A(t) {
  return t.isIp ? [] : L(t.psl.domain ?? t.url.hostname)?.map((e) => c(`https://${e}`)).filter(V) ?? [];
}
function Y(t, e) {
  const r = c(t);
  return r ? y(r, e) !== void 0 : !1;
}
function y(t, e) {
  const r = b(e, {
    usePunycode: !0
  }), i = B(t.url.port, r.port);
  if (i === void 0)
    return;
  const s = E(t, r.hostname);
  if (s === void 0)
    return;
  const n = j(t.url.pathname, r.pathname), a = F(t.url.search, r.search), u = N(t.url.hash, r.hash);
  return s * 1e6 + i * 1e4 + n * 100 + a + u;
}
function E(t, e) {
  if (t.isIp)
    return x(e) && t.url.hostname === e ? 1 : void 0;
  if (e = t.psl.listed && t.psl.sld === "www" ? e : $(e), !e || !t.url.hostname.endsWith(e))
    return;
  const r = S(e);
  if (r.error || // either both are on the psl, or none is
  t.psl.listed !== r.listed || t.psl.domain !== r.domain)
    return;
  const i = t.psl.listed ? t.psl.subdomain : t.url.hostname, s = r.listed ? r.subdomain : e, n = i?.split(".") ?? [], a = s?.split(".") ?? [];
  n.reverse(), a.reverse();
  const u = T(n, a);
  if (u !== void 0)
    return u + 1;
}
function $(t) {
  for (; t.startsWith("www."); )
    t = t.substring(4);
  return t;
}
function j(t, e) {
  const r = g(e), i = g(t), s = I(i, r), n = s.findIndex(([u, o]) => u !== o);
  if (n === -1)
    return r.length;
  const [, a] = s[n];
  if (a === void 0)
    return r.length;
  if (n !== 0) {
    const u = r.length - n;
    return -(u / (u + 1));
  }
  return -r.length;
}
function B(t, e) {
  if (e === "")
    return 0;
  if (e === t)
    return 1;
}
function F(t, e) {
  if (e === "")
    return 0;
  try {
    const r = p(new URLSearchParams(t)), i = p(new URLSearchParams(e));
    return M(r, i) ? 1 : 0;
  } catch {
    return 0;
  }
}
function p(t) {
  return Object.fromEntries(t.entries());
}
function N(t, e) {
  return e !== "" && t === e ? 1 : 0;
}
function c(t) {
  let e;
  try {
    e = new URL(t);
  } catch {
    return;
  }
  if (x(e.hostname))
    return {
      url: e,
      isIp: !0
    };
  const r = S(e.hostname);
  if (!r.error)
    return {
      url: e,
      isIp: !1,
      psl: r
    };
}
function x(t) {
  if (f.v4({
    exact: !0
  }).test(t))
    return !0;
  const e = /^\[([^\]]+)\]$/.exec(t);
  return e ? f.v6({
    exact: !0
  }).test(e[1]) : !1;
}
function g(t) {
  const e = t.replace(/^\/+|\/+$/g, "");
  return e === "" ? [] : e.split("/");
}
function T(t, e) {
  const r = I(t, e), i = r.findIndex(([n, a]) => n !== a);
  if (i === -1)
    return e.length;
  const [, s] = r[i];
  if (s === void 0)
    return e.length;
}
function I(t, e, r) {
  const i = Math.max, s = i(t.length, e.length);
  return Array.from(Array(s).keys()).map((n) => [t[n], e[n]]);
}
function V(t) {
  return t != null;
}
export {
  v as a,
  S as b,
  E as c,
  j as d,
  y as e,
  K as g,
  G as i,
  O as m,
  c as p,
  Y as u
};
//# sourceMappingURL=getLoginsForUrl-CvwpdvUD.js.map
